import { BiHome } from "react-icons/bi";
import Img500 from "../../../assets/img/500img.png";
import Button from "../../../components/button/button";
import "./error500.scss";

export default function Error500() {
    return (
        <div className="error-page">
            <img src={Img500} className="error-page__img" alt="" />
            <h1 className="error-page__title">
                500 - Error interno del servidor
            </h1>
            <p className="error-page__message">
                Ooops, algo salió mal en el servidor. Por favor, vuelve más
                tarde.
            </p>
            <Button
                label="Volver al inicio"
                path="/"
                variant="filled"
                icon={<BiHome />}
            />
        </div>
    );
}
